import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';

import {
  IAdvancedFormConfig,
  IAdvancedFormContainer,
  IAdvancedFormEvent,
  AdvancedFormEventTypes
} from '~shared/modules/advanced-form/models/advanced-form.model';
import { BadRequestHttpError } from '~shared/modules/error-handler';

import { AccountManagementDataService } from '../../services/account-management-data.service';
import { AccountManagementService } from '../../services/account-management.service';
import { IPrivateInfo } from '../../models/account-info.model';

@Component({
  selector: 'app-edit-private-info',
  styleUrls: ['./edit-private-info.component.scss'],
  templateUrl: './edit-private-info.component.html',
})
export class EditPrivateInfoComponent implements OnInit, IAdvancedFormContainer {
  public advancedFormConfig$: Observable<IAdvancedFormConfig>;

  constructor(
    private accountManagementDataService: AccountManagementDataService,
    private accountManagementService: AccountManagementService,
  ) {}

  public ngOnInit(): void {
    this.advancedFormConfig$ = this.accountManagementDataService.getAdvancedFormConfigForPrivateInfo();
  }

  public onAdvancedFormEvents(event: IAdvancedFormEvent): void {
    if (event.type === AdvancedFormEventTypes.submit) {
      const privateInfo = event.payload.formData as IPrivateInfo;
      this.accountManagementService.updatePrivateInfo(privateInfo, event.payload.isDirty).subscribe(
        () => event.done(),
        (error: BadRequestHttpError) => event.done(error.invalidParams),
      );
    }
  }
}
